import { Container, Row, Col, Alert } from 'reactstrap';
import styles from '../submit-schedule/submit-schedule.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthState } from '../../../store/auth-slice';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import useCountryDropdown from '../../../hooks/useCountryDropdown';
import { bookWorkspaceActions, getBookWorkspaceState } from '../../../store/book-workspace-slice';
import { fetchUserPresenceAsync, getTabViewState } from '../../../store/tab-view-slice';
import { AppDispatch } from '../../../store/store';
import { FluentButton } from "../../ui/fluent/fluent-component-wrapper";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { appInsights, reactPlugin } from '../../../config/app-insights';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Loader from '../../ui/fluent/loader';
import { StateIndicator } from '../../../models/shared/Enums/StateIndicator';
import { UserPresenceRequest } from '../../../models/api/types/UserPresence/UserPresenceRequest';
import {app, dialog} from "@microsoft/teams-js";

const LocationFilter: React.FC<any> = (props: any) => {

    const { t, i18n } = useTranslation();
    const authState = useSelector(getAuthState);
    const tabViewState = useSelector(getTabViewState);
    const bookWorkspaceState = useSelector(getBookWorkspaceState);
    const locationDropdown = useCountryDropdown();
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    useEffect(() => {

        if (authState.adminApiTokenStatus === StateIndicator.Success && tabViewState.locationStatus === StateIndicator.Success) {
            app.initialize();
            dispatch(bookWorkspaceActions.setBookWspceSelectedLocId(bookWorkspaceState.bookWspceSelectedLocId == 0 ? tabViewState.locations.data.personalSpaceDefaults.locationId : bookWorkspaceState.bookWspceSelectedLocId));
            fetchPresence();
        }
    }, [authState.adminApiTokenStatus, tabViewState.locationStatus, bookWorkspaceState.bookWspceSelectedLocId]);

    const bookDesk = async () => {
        let locationName = getLocationName();
        let dates = moment().format("YYYY-MM-DD");
        appInsights.trackEvent({ name: `${LocationFilter.name}/${bookDesk.name}: Booking a workspace availability`, properties: { TenantId: authState.tenantId, UserId: authState.adminApi?.userId, Datea: dates, LocationName: locationName } });
        navigate(`/bookWSAvailability?date=${dates}&locationId=${bookWorkspaceState.bookWspceSelectedLocId}&locationName=${locationName}`);
    }

    const getLocationName = (): string => {
        let locName = locationDropdown.current.filter((d: any) => {
            return d.id.toString() === bookWorkspaceState.bookWspceSelectedLocId?.toString();
        });
        return locName[0]?.name;
    }

    const getSelfCertificationStatus = (): boolean => {
        let loc = locationDropdown.current.filter((d: any) => {
            return d.id.toString() === bookWorkspaceState.bookWspceSelectedLocId?.toString();
        });
        return loc[0]?.certificate ?? false;
    }

    const prepareUserPresenceReq = async () => {
        const req: UserPresenceRequest = {
            userId: authState.adminApi?.userId ?? 0,
            inOfficeData: true,
            dates: [moment().format("YYYY-MM-DD")],
            memberEmails: [],
            locationId: bookWorkspaceState.bookWspceSelectedLocId == 0 ? (tabViewState?.locations?.data?.personalSpaceDefaults?.locationId ?? 0) : bookWorkspaceState.bookWspceSelectedLocId
        }
        return req;
    }

    const fetchPresence = async () => {
        const req = await prepareUserPresenceReq();
        dispatch(fetchUserPresenceAsync(req));
    }

    const closeTaskModule = async () => {
        dialog.url.submit();
    }

    const isUserBookedForToday = () => {
        if (tabViewState?.userPresence?.data?.dateWiseUserPresence?.length > 0) {
            const userpresence = tabViewState.userPresence.data.dateWiseUserPresence.find(presence => presence.date == moment().format("YYYY-MM-DD"))?.members.find(user => user.userId === authState.adminApi?.userId);
            if (userpresence != null && userpresence != undefined) {
                return !!userpresence.workspaceName?.length;
            }
        }
        return false;
    }

    const renderScreen = () => {
        if (locationDropdown.current != null && locationDropdown.current.length > 0
            && tabViewState.usePresenceStatus === StateIndicator.Success
            && tabViewState.appSettingsStatus === StateIndicator.Success
            && tabViewState.locationStatus === StateIndicator.Success) {        

            const isBlocked: boolean = tabViewState.locations?.data?.personalSpaceDefaults?.locationId == 0 || isUserBookedForToday() || !tabViewState.appSettings?.deskBookingAllowed || getSelfCertificationStatus();

            if(isBlocked){
                return (

                    <div id="submitScheduleView" className={`ent-teams-app ${styles['page-submit-schedule']}`}>
                        <header>
                            <Container fluid className="px-0">
                                <Row>
                                    <Col sm={12}>
                                        {tabViewState.locations?.data?.personalSpaceDefaults?.locationId == 0 && <Alert color={"warning"}>{t('TAB_79')}</Alert>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        {tabViewState.locations?.data?.personalSpaceDefaults?.locationId != 0 && isUserBookedForToday() && <Alert color={"warning"}>{t('TAB_78')}</Alert>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        {tabViewState.locations?.data?.personalSpaceDefaults?.locationId != 0 && !isUserBookedForToday() && !tabViewState.appSettings?.deskBookingAllowed && <Alert color={"danger"}>{t('TAB_80')}</Alert>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        {tabViewState.locations?.data?.personalSpaceDefaults?.locationId != 0 && !isUserBookedForToday() && tabViewState.appSettings?.deskBookingAllowed && getSelfCertificationStatus() && <Alert color={"danger"}><Trans i18nKey = {t('TAB_81')} components={{ 1: <br /> }} /></Alert>}
                                    </Col>
                                </Row>
    
                            </Container>
                        </header>
                        <footer>
                            <Container fluid className="px-0">
                                <div className={`${styles['form-action']} text-end`}>
                                    {(tabViewState.locations?.data?.personalSpaceDefaults?.locationId == 0 || isUserBookedForToday() || !tabViewState.appSettings?.deskBookingAllowed) && <FluentButton appearance="outline" onClick={closeTaskModule}>{t('TAB_14')}</FluentButton>}
                                </div>
                            </Container>
                        </footer>
                    </div>
    
    
    
                )
            }
            else{
                bookDesk();
            }
            
        }
        else {
            return <Loader />
        }
    }

    return (
        <>
            {renderScreen()}
        </>

    );
}

export default withAITracking(reactPlugin, LocationFilter, "location-filter");